import React from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import { Cancel, Block, CheckCircle, Compare, Shuffle } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
  },
  registrantSection: {
    padding: "0 0 10px 45px",
  },
  matchSection: {
    padding: "0 0 10px 55px",
  },
  items: {
    paddingTop: "10px",
  },
  box: {
    inlineSize: "250px",
    overflowWrap: "break-word",
  },
}));

export default function RegistrationMatchComponent({ label, registrationOne, registrationTwo, isMatch, getDisplay }) {
  const classes = useStyles();

  function defaultIsMatch(valA, valB) {
    if (!valA && !valB) {
      return "NO_DATA";
    }
    if (!valA || !valB) {
      return "NO_DATA";
    }
    if (valA === valB) {
      return "MATCH";
    }
    if (valA.includes(valB)) {
      return "PARTIAL_MATCH";
    }
    if (valB.includes(valA)) {
      return "PARTIAL_MATCH";
    }
    if (valA.includes("Unknown") || valA.includes("Unknown")) {
      return "PARTIAL_MATCH";
    }
    return "NO_MATCH";
  }

  // MATCH, NO_MATCH, NO_DATA, KINDA_MATCH, CROSS_MATCH
  const matchStatus = isMatch
    ? isMatch(registrationOne, registrationTwo)
    : defaultIsMatch(getDisplay(registrationOne), getDisplay(registrationTwo));

  return (
    <>
      <Grid container direction="row" justify="flex-start" alignItems="center">
        <Grid className={classes.registrantSection} item xs={5}>
          <Typography className={classes.items} variant="body2">
            <strong>{label} </strong>
          </Typography>
          <Typography className={classes.box} variant="body2">
            {getDisplay(registrationOne)}
          </Typography>
        </Grid>
        <Divider orientation="vertical" flexItem />
        <Grid item xs={1} style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
          {matchStatus === "MATCH" ? (
            <CheckCircle style={{ color: "#008000" }} />
          ) : matchStatus === "NO_DATA" ? (
            <Block />
          ) : matchStatus === "PARTIAL_MATCH" ? (
            <Compare style={{ color: "#FFC136" }} />
          ) : matchStatus === "CROSS_MATCH" ? (
            <Shuffle style={{ color: "#008000" }} />
          ) : (
            <Cancel style={{ color: "#ff0000" }} />
          )}
        </Grid>
        <Divider orientation="vertical" flexItem />
        <Grid className={classes.matchSection} item xs={5}>
          <Typography className={classes.items} variant="body2">
            <strong>{label} </strong>
          </Typography>
          <Typography className={classes.box} variant="body2">
            {getDisplay(registrationTwo)}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
